import { render, staticRenderFns } from "./DialogNovo.vue?vue&type=template&id=f0159dbe"
import script from "./DialogNovo.vue?vue&type=script&lang=js"
export * from "./DialogNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports